import React from "react";
import { Button } from "react-materialize";
import Func from "utils/Func";

export default function VireProfileBtnGContact({ data }) {
  return (
    <Button
      className=""
      id="btn-google-contact"
      node="button"
      waves="light"
      onClick={() =>
        (window.location.href = `https://contacts.google.com/${data.email}`)
      }
      style={{
        borderRadius: "8px",
        background: "#fff",
        color: "#7d7d7d",
        border: "2px solid #d1d1d1",
        boxShadow: "none",
      }}
    >
      <img
        src={`${Func.ImageUrl()}google_g_icon.png`}
        alt=""
        style={{
          position: "absolute",
          width: "40px",
          left: "5px",
          top: "-3px",
        }}
      />
      <span
        style={{
          fontWeight: "bold",
          display: "block",
          marginLeft: "28px",
          lineHeight: "20px",
        }}
      >
        Contact
      </span>
    </Button>
  );
}
